/** Wait for a delay or cancellation. False means aborted; either outcome disposes its timer and listener. */
export function waitUnlessAborted(ms, signal) {
  if (signal?.aborted) return Promise.resolve(false);
  if (ms <= 0) return Promise.resolve(true);
  const at = performance.now() + ms;
  return new Promise((resolve) => {
    let timer;
    const finish = (alive) => {
      if (timer !== undefined) clearTimeout(timer);
      signal?.removeEventListener('abort', onAbort);
      resolve(alive);
    };
    const onAbort = () => finish(false);
    const schedule = () => {
      const remaining = at - performance.now();
      if (remaining <= 0) finish(true);
      // Node and browsers clamp overflowing timeout values instead of waiting longer.
      else timer = setTimeout(schedule, Math.min(remaining, 2147483647));
    };
    signal?.addEventListener('abort', onAbort, { once: true });
    schedule();
  });
}
